import LearnPageLayout from "@/components/LearnPageLayout";
import { pageSaintVsTraditional } from "./learnDataSaintVsTraditional";

const SaintVsTraditionalPage = () => (
  <LearnPageLayout
    title={pageSaintVsTraditional.title}
    description={pageSaintVsTraditional.description}
    canonical={pageSaintVsTraditional.canonical}
    h1={pageSaintVsTraditional.h1}
    breadcrumbLabel={pageSaintVsTraditional.breadcrumbLabel}
    crumbs={pageSaintVsTraditional.crumbs}
    shortAnswer={pageSaintVsTraditional.shortAnswer}
    keyTakeaways={pageSaintVsTraditional.keyTakeaways}
    sections={pageSaintVsTraditional.sections}
    faqs={pageSaintVsTraditional.faqs}
    sources={pageSaintVsTraditional.sources}
    schemaJson={pageSaintVsTraditional.schemaJson}
    relatedLinks={pageSaintVsTraditional.relatedLinks}
    reviewBlock={pageSaintVsTraditional.reviewBlock}
    safetyBlock={pageSaintVsTraditional.safetyBlock}
    trademarkFooter={pageSaintVsTraditional.trademarkFooter}
    ctaBand={pageSaintVsTraditional.ctaBand}
  />
);

export default SaintVsTraditionalPage;
